// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"80be1b98","455":"6ae56d24","488":"c6a9610f","510":"cfb17dce","816":"cb2acd47","915":"d641bfed","977":"9bb7b69c"}[chunkId] + ".chunk.js";
};